import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CallbackService {
  constructor(private http: HttpClient) {}

  makeCallback(data): Observable<any> {
    return this.http.post('/async/ticket/init_call', data);
  }
}
